
const Modal = require('app/ui/Modal');
const ListTable = require('app/ui/list/Table');

class ProductCARankView {

    defaultOptions(){
        return {
            '$container': null,
            'data': null,
            'limit': 15,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickShowAll = this.onClickShowAll.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.data = this.settings.data;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$container
        .html('')
        .append(this.buildHeader())
        .append(this.buildList())

    }

    buildHeader(){
        let $header = $("<h3/>")
        .addClass('box-title')
        .append(window.translate('app.restaurant.show.tabs.stat.productCARank.title'))

        return $header;
    }

    buildList(){
        this.$list = $('<div/>');
        let limit = this.settings.limit;
        let $footerContent = null;
        if(this.data.length > limit){
            $footerContent = $("<tr/>")
            .append(
                $('<th/>')
                .attr('colspan',2)
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-center')
                    .append(
                        $('<button/>')
                        .addClass('btn btn-primary')
                        .append(window.translate('seeAll'))
                        .append(
                            $('<i/>')
                            .addClass('far fa-arrow-right ms-1')
                        )
                        .on('click',this.onClickShowAll)
                    )
                )
            )
        }

        this.drawTable(this.$list,limit,$footerContent);

        return this.$list;
    }

    drawTable($container,limit,$footerContent){
        let table = new ListTable({
            '$container': this.$list,
            'tableClass': 'table table-striped',
            'id': 'ordercount-list',
            'length': limit,
            'data': this.data,
            'footerContent': $footerContent,
            'columns': [
                {
                    'name': 'number',
                    'label': window.translate('app.restaurant.show.tabs.stat.product.number.label'),
                    'class': 'product-number',
                    'render': function(item,index){
                        return item.product.number;
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('app.restaurant.show.tabs.stat.product.reference.label'),
                    'class': 'product-reference',
                    'render': function(item,index){
                        return item.product.reference;
                    },
                },
                {
                    'name': 'total',
                    'label': window.translate('total'),
                    'class': 'total',
                    'render': function(item,index){
                        return window.formatFloat(item.netSale) + ' &euro;';
                    },
                }
            ]
        });
    }

    onClickShowAll(event){
        event.preventDefault();
        event.stopPropagation();

        let $content = $('<div/>');

        this.drawTable($content,0,null);

        let modal = new Modal({
            'title': window.translate('app.restaurant.show.tabs.stat.productVolumeRank.title'),
            'modalSize': 'full',
            'content': $content
        });
        modal.show();
    }
}

module.exports = ProductCARankView;

